import * as ApiCons from "@/api/http/ins/insConst";
import Http from "@/api/http/fetch";
import * as InsRequest from "@/api/http/ins/insBase";
import store from "@/store";
import * as types from "@/store/constants/types";
import { getUUid, signBody, creatUUid } from "@/api/http/utils/apiHelpers";
import {
  getActionCloseCookie,
  clearActionCloseCookie
} from "@/api/http/ins/insCookieManager";
import {
  sendEventError,
  sendEvent,
  sendIGError,
  sendIGSuccess
} from "@/utils/analytics";

/**
 * 引入Http请求用于JS Bridge方法,非用于其实例方法
 */

/**
 * 用于sign需要的body，返回object
 */

/**
 * [INS的登陆]
 * @param userName
 * @param passWord
 */
let attemptCount = 0;
export const LoginByIns = (
  userName: string | number,
  passWord: string | number
) => {
  return new Promise(async (resolve, reject) => {
    try {
      //注意：登陆前清除原生缓存的cookie
      await Http.ClearAllCookies();
      const uid = getUUid();

      const loginInfo = {
        reg_login: 0,
        username: userName,
        password: passWord,
        device_id: uid,
        phone_id: uid,
        login_attempt_count: attemptCount
      };
      attemptCount++; //尝试次数
      const data: any = await signBody(loginInfo);
      const preloadParams: any = {
        requestType: "multipart/form-data",
        cookieHandle: false //不自动注入默认的cookie
      };
      if (getActionCloseCookie()) {
        preloadParams.headers = {};
        preloadParams.headers.Cookie = getActionCloseCookie();
        clearActionCloseCookie();
      }
      const result = await InsRequest.post(
        ApiCons.loginUrl,
        { data },
        {
          ...preloadParams
        }
      );
      successSendEvent("LoginByIns");
      sendIGSuccess("LoginByIns");
      resolve(result);
    } catch (error) {
      failSendEvent(error, "LoginByIns");
      sendIGError(error, "LoginByIns");
      reject(error);
    }
  });
};

export const loginByFb = (accessToken: string) =>
  new Promise(async (resolve, reject) => {
    try {
      const uid = await getUUid();
      const uuid32 = uid.toLowerCase().replace(/-/g, "");
      const loginInfo = {
        dryrun: "true",
        waterfall_id: uuid32,
        device_id: uid,
        allow_contacts_sync: "false",
        fb_access_token: accessToken,
        phone_id: uid
      };
      const data: any = await signBody(loginInfo);
      const preloadParams: any = {
        requestType: "multipart/form-data",
        cookieHandle: false
      };
      if (getActionCloseCookie()) {
        preloadParams.headers = {};
        preloadParams.headers.Cookie = getActionCloseCookie();
        clearActionCloseCookie();
      }
      const result = await InsRequest.post(
        ApiCons.loginFBUrl,
        { data },
        {
          ...preloadParams
        }
      );
      sendIGSuccess("loginByFb");
      sendEventError("uia_facebook_login_api", {
        error_code: "200",
        error_message: "ok"
      });
      if (result.logged_in_user) {
        resolve(result);
      } else {
        reject(result);
      }
    } catch (error) {
      const error_message =
        error &&
        error.error &&
        (error.error.message || error.error.NSLocalizedDescription);
      const errCode = error.code || 400;
      sendEventError("uia_facebook_login_api", {
        error_code: errCode.toString(),
        error_message
      });
      sendIGError(error, "loginByFb");
      reject(error);
    }
  });

function transformChallengeURLString(urlString: any, operators: any = false) {
  const index = urlString.indexOf("challenge");
  let path = urlString.substring(
    operators ? index + "UrlParser".length + 1 : index
  );
  if (path.search(/(.+?\/$)/) === -1) {
    path += "/";
  }
  const newPath = operators
    ? `${ApiCons.baseUrl}api/v1/challenge/${operators}/${path}`
    : `${ApiCons.baseUrl}api/v1/${path}`;
  console.log("transformChallengeURLString", newPath);
  return newPath;
}

const successSendEvent = (name: any) => {
  sendEventError("uia_ins_login_api_" + name, {
    error_code: "200",
    error_message: "ok"
  });
};

const failSendEvent = (error: any, name: any) => {
  const error_message =
    error &&
    error.error &&
    (error.error.message || error.error.NSLocalizedDescription);
  const errCode = error.code || 400;
  sendEventError("uia_ins_login_api_" + name, {
    error_code: errCode.toString(),
    error_message
  });
};

export function fetchChallenge(url: string) {
  return new Promise(async (resolve, reject) => {
    try {
      const uid = await getUUid();
      const params = { device_id: uid };
      const result = await InsRequest.get(
        transformChallengeURLString(url, false),
        {
          params
        },
        {
          chainCookie: true //不自动注入默认的cookie
        }
      );
      successSendEvent("fetchChallenge");
      sendIGSuccess("fetchChallenge");
      resolve(result);
    } catch (error) {
      failSendEvent(error, "fetchChallenge");
      sendIGError(error, "fetchChallenge");
      reject(error);
    }
  });
}

export const sendChallenge = (url: string, choice: number | string) => {
  return new Promise(async (resolve, reject) => {
    try {
      const uid = await getUUid();
      const info = {
        device_id: uid,
        choice,
        _uuid: uid
      };
      const data = await signBody(info);
      const result = await InsRequest.post(
        transformChallengeURLString(url, false),
        {
          data
        },
        {
          requestType: "multipart/form-data",
          chainCookie: true //不自动注入默认的cookie
        }
      );
      successSendEvent("sendChallenge");
      sendIGSuccess("sendChallenge");
      resolve(result);
    } catch (error) {
      failSendEvent(error, "sendChallenge");
      sendIGError(error, "sendChallenge");
      reject(error);
    }
  });
};

export const resetChallenge = (url: string) =>
  new Promise(async (resolve, reject) => {
    try {
      const info = { device_id: await getUUid() };
      const data = await signBody(info);
      const result = await InsRequest.post(
        transformChallengeURLString(url, "reset"),
        { data },
        {
          requestType: "multipart/form-data",
          chainCookie: true //不自动注入默认的cookie
        }
      );
      successSendEvent("resetChallenge");
      sendIGSuccess("resetChallenge");
      resolve(result);
    } catch (error) {
      failSendEvent(error, "resetChallenge");
      sendIGError(error, "resetChallenge");
      reject(error);
    }
  });

export const verifyChallenge = (url: string, code: string | number) => {
  return new Promise(async (resolve, reject) => {
    try {
      const uid = await getUUid();
      const info = {
        device_id: uid,
        security_code: code
      };
      const data = await signBody(info);
      const result = await InsRequest.post(
        transformChallengeURLString(url, false),
        {
          data
        },
        {
          requestType: "multipart/form-data",
          chainCookie: true //不自动注入默认的cookie
        }
      );
      successSendEvent("verifyChallenge");
      sendIGSuccess("verifyChallenge");
      resolve(result);
    } catch (error) {
      failSendEvent(error, "verifyChallenge");
      sendIGError(error, "verifyChallenge");
      reject(error);
    }
  });
};

export const verifyTwoFactor = (
  twoFactorInfo: any,
  verificationCode: string
) => {
  return new Promise(async (resolve, reject) => {
    try {
      const uid = await getUUid();
      const loginInfo = {
        verification_code: verificationCode,
        username: twoFactorInfo.username,
        device_id: uid,
        two_factor_identifier: twoFactorInfo.two_factor_identifier
      };
      const data = await signBody(loginInfo);
      const result = await InsRequest.post(
        ApiCons.loginWithTwoFactorUrl,
        {
          data
        },
        {
          requestType: "multipart/form-data",
          chainCookie: true //不自动注入默认的cookie
        }
      );
      successSendEvent("verifyTwoFactor");
      sendIGSuccess("verifyTwoFactor");
      resolve(result);
    } catch (error) {
      failSendEvent(error, "verifyTwoFactor");
      sendIGError(error, "verifyTwoFactor");
      reject(error);
    }
  });
};

/**
 * 通过userId 获取用户的ins user info
 * @param userId
 * @param handleErr
 * @param fromWorker
 */
export const getInsUserInfoById = (
  userId: string | number,
  handleErr = true,
  fromWorker = false
) => {
  return new Promise(async (resolve, reject) => {
    try {
      const extra = { userId, handleErr, fromWorker };
      const result = await InsRequest.get(
        ApiCons.getUserInfoByIdUrl(userId),
        {
          params: { device_id: await getUUid() }
        },
        extra
      );
      sendIGSuccess("getInsUserInfoById");
      resolve(result);
    } catch (error) {
      sendIGError(error, "getInsUserInfoById");
      reject(error);
    }
  });
};

/**
 * 通过用户名获取ins user info
 * @param username
 * @param handleErr
 * @param fromWorker
 */
export const getUserInfoByName = (
  username: string,
  handleErr = true,
  fromWorker = false
) =>
  new Promise(async (resolve, reject) => {
    try {
      const extra = {
        handleErr,
        fromWorker
      };
      const result = await InsRequest.get(
        ApiCons.getUserInfoByNameUrl(username),
        extra
      );
      sendIGSuccess("getUserInfoByName");
      resolve(result);
    } catch (error) {
      sendIGError(error, "getUserInfoByName");
      reject(error);
    }
  });

/**
 * 获取ins media的list的
 * @param userId
 * @param maxId
 * @param handleErr
 * @param fromWorker
 */
export const getInsUserMediaById = (
  userId: string | number,
  maxId?: string | number,
  handleErr = true,
  fromWorker = false
) => {
  return new Promise(async (resolve, reject) => {
    try {
      const uid = getUUid();
      const params: any = { phone_id: `${userId}_${uid}` };
      if (maxId !== undefined && maxId !== null) {
        params.max_id = maxId;
      }
      const extra = { userId, handleErr, fromWorker };
      const result = await InsRequest.get(
        ApiCons.getUserFeedUrl(userId),
        {
          params
        },
        extra
      );
      sendIGSuccess("getInsUserMediaById");
      resolve(result);
    } catch (error) {
      if (
        error &&
        error.error &&
        error.error.message &&
        error.error.message.indexOf("authorized") > -1
      ) {
        //请求了私密账户，没有权限，这时候也要返回成功，让私密账户自己判断
        //传入假数据
        const insUserMedia = {
          items: [],
          more_available: false,
          next_max_id: null
        };
        resolve(insUserMedia);
        return;
      }
      sendIGError(error, "getInsUserMediaById");
      reject(error);
    }
  });
};

/**
 * 获取media单个的信息
 * @param userId
 * @param mediaId
 * @param handleErr
 * @param fromWorker
 */

export const getMediaInfo = (
  userId: string | number,
  mediaId: string | number,
  handleErr = true,
  fromWorker = false
) => {
  return new Promise(async (resolve, reject) => {
    try {
      const params = { device_id: await getUUid() };
      const extra = { userId, handleErr, fromWorker };
      const result = await InsRequest.get(
        ApiCons.getMediaInfoUrl(mediaId),
        { params },
        extra
      );
      sendIGSuccess("getMediaInfo");
      resolve(result);
    } catch (error) {
      sendIGError(error, "getMediaInfo");
      reject(error);
    }
  });
};

/**
 * 搜索用户
 * @param queryUser
 * @param userId
 */
export const searchUser = (queryUser: string, userId: number | string) => {
  return new Promise(async (resolve, reject) => {
    try {
      const uid = getUUid();
      const params = {
        query: queryUser,
        is_typeahead: true,
        rank_token: userId + "_" + uid,
        timezone_offset: new Date().getTime() / 1000
      };
      const result = await InsRequest.get(ApiCons.searchUserUrl, {
        params
      });
      sendIGSuccess("searchUser");
      resolve(result);
    } catch (error) {
      sendIGError(error, "searchUser");
      reject(error);
    }
  });
};
/**
 * ins主动follow
 * @param userId
 * @param mediaId
 * @param handleErr
 * @param fromWorker
 */
export const hitFollow = (
  userId: any,
  mediaId: any,
  handleErr = true,
  fromWorker = false
) => {
  return new Promise(async (resolve, reject) => {
    try {
      const info = {
        _uuid: await getUUid(),
        _csrftoken: await store.getters[types.GETTER_CROS_TOKEN_BY_USER_ID](
          userId
        ),
        _uid: userId,
        user_id: mediaId
      };
      const data = await signBody(info);
      const extra = {
        userId,
        handleErr,
        fromWorker,
        requestType: "multipart/form-data"
      };
      const result = await InsRequest.post(
        ApiCons.onFollowUrl(mediaId),
        { data },
        extra
      );
      sendIGSuccess("hitFollow");
      resolve(result);
    } catch (error) {
      sendIGError(error, "hitFollow");
      reject(error);
    }
  });
};

/**
 * ins 主动去like
 * @param userId
 * @param mediaId
 * @param handleErr
 * @param fromWorker
 */
export const hitLike = (
  userId: any,
  mediaId: any,
  handleErr = true,
  fromWorker = false
) =>
  new Promise(async (resolve, reject) => {
    try {
      const info = {
        _uuid: await getUUid(),
        module_name: "photo_view",
        _uid: userId,
        user_id: mediaId.split("_")[1],
        media_id: mediaId,
        _csrftoken: await store.getters[types.GETTER_CROS_TOKEN_BY_USER_ID](
          userId
        )
      };
      const data = await signBody(info);
      const extra = {
        userId,
        handleErr,
        fromWorker,
        requestType: "multipart/form-data"
      };
      const result = await InsRequest.post(
        ApiCons.likeMediaUrl(mediaId),
        { data },
        extra
      );
      sendIGSuccess("hitLike");
      resolve(result);
    } catch (error) {
      sendIGError(error, "hitLike");
      reject(error);
    }
  });

/**
 * 主动去comments
 * @param userId
 * @param mediaId
 * @param comment
 * @param handleErr
 * @param fromWorker
 */
export const hitComment = (
  userId: any,
  mediaId: any,
  comment: any,
  handleErr = true,
  fromWorker = false
) =>
  new Promise(async (resolve, reject) => {
    try {
      const info = {
        _uuid: await getUUid(),
        _csrftoken: await store.getters[types.GETTER_CROS_TOKEN_BY_USER_ID](
          userId
        ),
        _uid: userId,
        idempotence_token: creatUUid().toLowerCase(),
        comment_text: comment,
        containermodule: "comments_single_feed_profile"
      };
      const data = await signBody(info);
      const extra = {
        userId,
        handleErr,
        fromWorker,
        requestType: "multipart/form-data"
      };
      const result = await InsRequest.post(
        ApiCons.postMediaCommentUrl(mediaId),
        { data },
        extra
      );
      sendIGSuccess("hitComment");
      resolve(result);
    } catch (error) {
      sendIGError(error, "hitComment");
      reject(error);
    }
  });

export const postAccountSetPublic = (userId: any) =>
  new Promise(async (resolve, reject) => {
    try {
      const info = {
        _uuid: await getUUid(),
        _csrftoken: await store.getters[types.GETTER_CROS_TOKEN_BY_USER_ID](
          userId
        )
      };
      const extra = { userId, handleErr: false, fromWorker: false };
      const data = await signBody(info);
      const result = await InsRequest.post(
        ApiCons.postAccountSetPublicUrl,
        { data },
        extra
      );
      sendIGSuccess("postAccountSetPublic");
      resolve(result);
    } catch (error) {
      sendIGError(error, "postAccountSetPublic");
      console.log("postAccountSetPublic error:", error);
      reject(error);
    }
  });

export const searchInsUser = (user_name: string, user_id: number) =>
  new Promise(async (resolve, reject) => {
    try {
      const _uuid = await getUUid();
      const extra = { user_id };
      const params = {
        from_module: "single_feed_profile",
        device_id: _uuid
      };
      const result = await InsRequest.get(
        ApiCons.GET_USER_INFO_BY_NAME_URL(encodeURIComponent(user_name)),
        {
          params
        },
        extra
      );
      resolve(result);
      sendIGSuccess("IGAccountCommenterControlSwitchAction");
    } catch (error) {
      reject(error);
      sendIGError("IGAccountCommenterControlSwitchAction", error);
    }
  });
